module.exports = __webpack_public_path__ + "img/crate-apple.8bbdf6e1.svg";